import React from 'react';
import { FIVERR_LOGOS_SIZES } from '../../constants';
import type { FiverrLogosType } from '../../types';
import { pascalToSnake } from '../../../utils';

const FiverrLogo = ({ size = 'md', dataTrackTag = pascalToSnake('FiverrLogo') }: FiverrLogosType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={FIVERR_LOGOS_SIZES[size].width}
    height={FIVERR_LOGOS_SIZES[size].height}
    fill="none"
    viewBox="0 0 120 36"
    data-track-tag={dataTrackTag}
  >
    <path
      fill="#003912"
      d="M110.04 17.413h-4.247c-2.735 0-4.198 2.055-4.198 5.478v12.376h-8.056V17.413h-3.417c-2.734 0-4.198 2.055-4.198 5.478v12.376h-8.056V10.81h8.056v3.717c1.319-2.886 3.125-3.717 5.81-3.717h9.862v3.717c1.319-2.886 3.125-3.717 5.81-3.717h2.636v6.603zm-33.93 7.533H59.316c.44 2.74 2.147 4.304 5.028 4.304 2.147 0 3.66-.88 4.15-2.446l7.127 2.006c-1.757 4.255-6.102 6.848-11.277 6.848-8.739 0-12.743-6.8-12.743-12.62 0-5.722 3.515-12.57 12.254-12.57 9.276 0 12.352 6.945 12.352 12.081a25 25 0 0 1-.097 2.397M68.298 20.2c-.195-2.104-1.709-4.06-4.442-4.06-2.54 0-4.052 1.125-4.54 4.06zM37.542 35.267h7.079l8.837-24.456h-8.104l-4.296 14.233-4.395-14.234h-8.056zm-33.001 0h8.006V17.413h7.616v17.854h7.958V10.81H12.547V9.294c0-1.663 1.172-2.69 3.027-2.69h4.59V0h-5.908c-5.81 0-9.715 3.571-9.715 8.804v2.006H0v6.603h4.54z"
    />
    <path
      fill="#1DBF73"
      d="M115.02 36c2.75 0 4.98-2.234 4.98-4.99 0-2.755-2.23-4.99-4.98-4.99a4.984 4.984 0 0 0-4.98 4.99 4.984 4.984 0 0 0 4.98 4.99"
    />
  </svg>
);
FiverrLogo.displayName = 'FiverrLogo';
export default FiverrLogo;
